// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__it4wI","actionColumn":"ReferralSources_actionColumn__UUeX3","textButton":"ReferralSources_textButton__1eN5o"};